import { ReportLayout } from '@app/components/reports/components/report-layout';
import { OperationReportTypeEnum } from '@shared/api/types';
import { useParams } from 'react-router-dom';
import SalesReportLayoutHeader from './components/sales-report-layout-header';
import { useSalesReportResult } from './sales-report-result-context';
import { useSalesReportSections } from './sales-report-sections';
import { useSalesFormattedReportSections } from './sales-report-utils';
import SalesReportIntro from './sections/sales-report-intro';

export default function SalesReport() {
  const { report_uuid } = useParams();
  const { result, resultStatus, resultError, downloadMode } =
    useSalesReportResult();

  const reportSections = useSalesReportSections(result, report_uuid!);
  const data = useSalesFormattedReportSections(reportSections, result);

  return (
    <ReportLayout
      reportType={OperationReportTypeEnum.sales}
      reportUuid={report_uuid!}
      title={result?.title}
      organizationName={result?.organization.name}
      resultStatus={resultStatus}
      resultError={resultError}
      introComponent={<SalesReportIntro />}
      headerComponent={<SalesReportLayoutHeader />}
      data={data}
      sections={reportSections}
      defaultActive={'Introduction'}
      downloadMode={downloadMode}
    />
  );
}
